export default {
  failure: '#E56657',
  warning: '#FABD59',
  info: '#2D9CDB',
  success: '#27AE60',

  disabled: {
    light: '#ffffff',
    main: '#fff',
    dark: '#4f4f4f',
    contrast: '#4f4f4f',
  },
  primary: {
    light: '#ffffff',
    main: '#fafafa',
    dark: '#4f4f4f',
    contrast: '#4f4f4f',
  },
  secondary: {
    light: '#fff',
    main: '#edfffc',
    dark: 'rgba(0, 36, 76, 1)',
    contrast: '#ffffff',
  },
  tertiary: {
    light: '#fff',
    main: '#fff',
    dark: 'rgba(0, 64, 130, 1)',
    contrast: '#FFFFFF',
  },
  accent: {
    light: '#fff',
    main: '#fff',
    dark: '#fff',
    contrast: '#ffffff',
  },
} as ColorType;
